import _remove from 'lodash/remove';
import * as CommentActions from '../actions/comment';
import reducerWithActionMap from "../utils/reducerWithActionsMap";

const initialState = {
  isAuthenticated: false,
  commentList: {
    isFetching: false,
    isFetched: false,
    listData: [],
    total: 0,
  },
  predefinedCommentList: {
    isFetching: false,
    isFetched: false,
    listData: [],
    total: 0,
  },
  commentDetails: {
    isFetching: false,
    isFetched: false,
    commentData: null,
  },
};

const setCommentListFetching = fetching => state => ({
  ...state,
  commentList: {
    ...state.commentList,
    isFetching: fetching,
  },
});

const setPredefinedCommentListFetching = fetching => state => ({
  ...state,
  predefinedCommentList: {
    ...state.predefinedCommentList,
    isFetching: fetching,
  },
});

const setCommentList = (state, { payload: { listData, total } }) => ({
  ...state,
  commentList: {
    ...state.commentList,
    listData,
    total,
    isFetching: false,
    isFetched: true,
  },
});

const setPredefinedCommentList = (state, { payload: { listData, total } }) => ({
  ...state,
  predefinedCommentList: {
    ...state.predefinedCommentList,
    listData,
    total,
    isFetching: false,
    isFetched: true,
  },
});

const setCommentFetching = fetching => state => ({
  ...state,
  commentDetails: {
    ...state.commentDetails,
    isFetching: fetching,
  },
});

const setComment = (state, { payload: { commentData } }) => ({
  ...state,
  commentDetails: {
    ...state.commentDetails,
    commentData,
    isFetching: false,
    isFetched: true,
  },
});

const setCommentDeleted = (state, { payload: { commentId } }) => {
  const newListData = state.commentList.listData;
  _remove(newListData, { id: commentId });

  const newState = {
    ...state,
    commentList: {
      ...state.commentList,
      listData: newListData,
    },
  };
  return newState;
};

const actionMap = {
  [CommentActions.LIST_COMMENT_REQUEST]: setCommentListFetching(true),
  [CommentActions.LIST_COMMENT_SUCCESS]: setCommentList,
  [CommentActions.LIST_COMMENT_FAILURE]: setCommentListFetching(false),
  [CommentActions.DELETE_COMMENT_SUCCESS]: setCommentDeleted,
  [CommentActions.FETCH_COMMENT_REQUEST]: setCommentFetching(true),
  [CommentActions.FETCH_COMMENT_SUCCESS]: setComment,
  [CommentActions.FETCH_COMMENT_FAILURE]: setCommentFetching(false),
  [CommentActions.LIST_PREDEFINED_COMMENT_REQUEST]: setPredefinedCommentListFetching(true),
  [CommentActions.LIST_PREDEFINED_COMMENT_SUCCESS]: setPredefinedCommentList,
  [CommentActions.LIST_PREDEFINED_COMMENT_FAILURE]: setPredefinedCommentListFetching(false),
};

export default reducerWithActionMap(actionMap, initialState);


